import { Form, message } from "antd";
import { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./deletedAudits.css";
import {
  ParseElementsIntoFormNew,
  getScore,
  getScoreQuestionCount,
  getDateAfterWeek,
} from "../../../../parser";
import DeletedAuditDetails from "./deletedAuditDetails";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import CustomLoader from "../../common/customLoader";
import { getDeletedAuditDetailThunk } from "../../../store/thunks/deletedAuditsThunk";
import { useDispatch, useSelector } from "react-redux";
import media from "../../../media";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";

const DeletedAuditView = ({
  children = null,
  key_elem = "1",
  nameLink = "",
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [qualityScore, setQualityScore] = useState(0);
  const [auditFormAction, setAuditFormAction] = useState("");
  const location = useLocation();
  const [form] = Form.useForm();
  const [formValue, SetFormValue] = useState({});
  const [formSavingFieldType, setFormSavingFieldType] = useState("");
  const [QMF, setQMF] = useState({});
  const prevData = location?.state;
  const rawAccess = useSelector((state) => state.auth.access);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const maxScore = getScoreQuestionCount(QMF);
  const [scoreQuestionCount, setScoreQuestionCount] = useState(0);
  const [crrScore, setCrrScore] = useState(0);
  const [fatalNotFatal, setFatalNotFatal] = useState({});
  const [fatalCount, setFatalCount] = useState(0);
  const [notFatalCount, setNotFatalCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const id = location.pathname.split("/")[2];
  const [value, setValue] = useState("");
  const [aID, setAID] = useState("");
  const [tid, setTid] = useState("");
  const [commentStatus, setCommentStatus] = useState("0");
  const [isAuditorImgBroken, setIsAuditorImgBroken] = useState(false);

  const [showDiv, setShowDiv] = useState(false);

  const [showLoader, setShowLoader] = useState(true);
  const [isCritical, setIsCritical] = useState(false);

  /*setAuditFormInput state is used to show Perform Audit selected fields on Audit Form*/
  const [auditFormInput, setAuditFormInput] = useState({});

  const [auditFormHasWeightage, setAuditFormHasWeightage] = useState("FALSE");
  const [dateCount, setDateCount] = useState(0);

  {
    /*Feedback*/
  }
  const [addAgentFeedback, setAddAgentFeedback] = useState(0);
  const [agentFeedback, setAgentFeedback] = useState("");
  const [addSupervisorFeedback, setAddSupervisorFeedback] = useState(0);
  const [supervisorFeedback, setSupervisorFeedback] = useState("");
  const [auditorProfileImage, setAuditorProfileImage] = useState("");
  const [agentProfileImage, setAgentProfileImage] = useState("");

  // Create an object to store subarrays
  var fatalNotFatalArr = {};

  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(
    accessMap,
    "qMSDeletedAuditsDetailView",
    "view",
  );
  useEffect(() => {
    getAuditDetail();
  }, [location?.state?.route === "/auditForms"]);

  //begin:: show Audit Form
  const getAuditDetail = () => {
    if (secureLocalStorage.getItem("auditFormCall") === "performAuditUpdate") {
      const allKeys = Object.keys(localStorage);
      let removeItems;
      removeItems = ["@secure.n.totalAuditedCount"];
      allKeys &&
        allKeys.forEach((key) => {
          if (removeItems && removeItems.includes(key)) {
            localStorage.removeItem(key);
          }
        });
    }
    if (window.performance) {
      const entries = performance.getEntriesByType("navigation");
      if (
        secureLocalStorage.getItem("clickedLink") !== "auditsDetailLinkClick"
      ) {
        if (entries.length > 0 && entries[0].type === "reload") {
          // Page is refreshed
          secureLocalStorage.setItem("clickedLink", "auditsDetailLinkVisit");
        }
      } else {
        if (secureLocalStorage.getItem("auditFormCall") === "performAudit") {
          // Page is refreshed
          secureLocalStorage.setItem("clickedLink", "auditsDetailLinkVisit");
        } else {
        }
      }
    }

    const payloadID = `${
      secureLocalStorage.getItem("savedAuditId") !== null &&
      (secureLocalStorage.getItem("auditFormCall") === null ||
        secureLocalStorage.getItem("auditFormCall") === "performAuditUpdate") &&
      secureLocalStorage.getItem("fromComponent") !== "audits"
        ? secureLocalStorage.getItem("savedAuditId")
        : id
    }`;

    const payload = { id: payloadID };

    dispatch(getDeletedAuditDetailThunk(payload))
      .unwrap()
      .then((response) => {
        if (response?.auditor) {
          setAuditorProfileImage({
            name: response?.auditor?.name,
            profilePicUrl: response?.auditor?.profilePicUrl
              ? process.env.REACT_APP_BACKEND +
                "/images/" +
                response?.auditor?.profilePicUrl
              : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
          });
        }
        if (response?.agent) {
          setAgentProfileImage({
            name: response?.agent?.name,
            profilePicUrl: response?.agent?.profilePicUrl
              ? process.env.REACT_APP_BACKEND +
                "/images/" +
                response?.agent?.profilePicUrl
              : process.env.REACT_APP_BACKEND + "/images/dummy.jpg",
          });
        }

        if (response.supervisorFeedback === null) {
          setAddSupervisorFeedback(1);
        }
        if (response.agentFeedback === null) {
          setAddAgentFeedback(1);
        }
        if (response?.supervisorFeedback) {
          setSupervisorFeedback(
            JSON.parse(response?.supervisorFeedback)?.status,
          );
        }
        if (response?.agentFeedback) {
          setAgentFeedback(JSON.parse(response?.agentFeedback)?.status);
        }
        if (response?.fatalNotFatalInfo) {
          setFatalCount(JSON.parse(response?.fatalNotFatalInfo)?.fatal);
          setNotFatalCount(JSON.parse(response?.fatalNotFatalInfo)?.notFatal);
        }
        if (response?.auditedScoreInfo) {
          setCrrScore(
            JSON.parse(response?.auditedScoreInfo)?.auditedQuestionCount,
          );
          setScoreQuestionCount(
            JSON.parse(response?.auditedScoreInfo)?.auditedMaxQuestionCount,
          );
          setQualityScore(JSON.parse(response?.auditedScoreInfo)?.score);
        }

        secureLocalStorage.removeItem("parameterSelectedList");
        let questions = JSON.parse(response?.formContent)?.elements?.questions;

        let count = 1;
        let dcount = 1;
        let totalWeightage = 0;

        // Initialize subarrays
        fatalNotFatalArr["fatal"] = [];
        fatalNotFatalArr["notFatal"] = [];

        secureLocalStorage.setItem("totalAuditedCount", 0);

        for (let i = 0; i < questions?.length; i++) {
          if (questions[i].meta.weightage) {
            totalWeightage = totalWeightage + questions[i].meta.weightage;
            setAuditFormHasWeightage("TRUE");
          }
          if (questions[i].input_type === "radio-group") {
            if (!response?.auditedScoreInfo) {
              setScoreQuestionCount(count);
            }
            secureLocalStorage.setItem("totalAuditedCount", count++);
          }

          if (questions[i].input_type === "date") {
            setDateCount(dcount++);
          }
          if (questions[i].meta?.critical === true) {
            if (questions[i].qkey) {
              fatalNotFatalArr["fatal"].push(questions[i].qkey);
            }
          } else {
            if (questions[i].qkey) {
              fatalNotFatalArr["notFatal"].push(questions[i].qkey);
            }
          }
          if (questions[i].selectedValue && questions[i].selectedValue !== "") {
            SetFormValue((state) => ({
              ...state,
              [questions[i].qkey]: [
                questions[i].selectedValue,
                questions[i].meta.isQualityMetric,
                questions[i].meta.weightage,
                totalWeightage,
              ],
            }));
          }
        }
        setFatalNotFatal(fatalNotFatalArr);

        setAuditFormInput(secureLocalStorage.getItem("auditFormInput"));
        if (secureLocalStorage.getItem("auditFormCall") !== "performAudit") {
          setAuditFormInput({
            Stage: { icon: "auditStag", value: response?.stage },
            Auditor: { icon: "auditAuditor", value: response?.auditor?.name },
            "Audit Score": {
              icon: "auditScoree",
              value: response?.auditedScoreInfo?.score,
            },
            Client: { icon: "auditClient", value: response?.client?.name },
            Department: {
              icon: "auditDepartment",
              value: response?.department?.name,
            },
            Process: { icon: "auditProcess", value: response?.process?.name },
            "Audit Form": {
              icon: "auditForm",
              value: response?.auditForm?.formName,
            },
            Transaction: {
              icon: "auditTransaction",
              value: response?.transaction_id,
            },
            Status: {
              icon: "departmentStatus",
              value: response?.status.toString(),
            },
            agent: {
              icon: "auditAgent",
              value:
                response?.agent?.name +
                " (Emp ID: " +
                response?.agent?.empID +
                ")",
            },
          });

          if (response?.auditBackDateReason) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Reason for Audit's back date": {
                icon: "auditAgent",
                value: response?.auditBackDateReason,
              },
            }));
          }
          if (response?.transactionDuplicateReason) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Reason for duplicate Transaction ID": {
                icon: "auditAgent",
                value: response?.transactionDuplicateReason,
              },
            }));
          }
          if (response?.insuredName) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Insured Name": {
                icon: "auditInsure",
                value: response?.insuredName,
              },
            }));
          }
          if (response?.transactionAmount) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Transaction Amount": {
                icon: "auditAgent",
                value: response?.transactionAmount,
              },
            }));
          }
          if (response?.invoiceCount) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Invoice Count": {
                icon: "auditAgent",
                value: response?.invoiceCount,
              },
            }));
          }
          if (response?.agentFeedback) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Agent Feedback": {
                icon: "auditAgent",
                value: JSON.parse(response?.agentFeedback)?.status,
              },
            }));
          }
          if (response?.supervisorFeedback) {
            setAuditFormInput((prevState) => ({
              ...prevState, // Spread the previous state to retain existing key-value pairs
              "Supervisor Feedback": {
                icon: "auditAgent",
                value: JSON.parse(response?.supervisorFeedback)?.status,
              },
            }));
          }
          secureLocalStorage.setItem("timeStampsDetails", {
            CreatedAt: response?.createdAt,
            UpdatedAt: response?.updatedAt,
          }); //For showing TimeStamp Details on View Audit after saving

          secureLocalStorage.setItem("savePayloadRequestParams", {
            clientId: response?.client?._id,
            departmentId: response?.department?._id,
            processId: response?.process?._id,
            transactionId: response?.transaction_id,
            transactionDate: response?.transactionDate,
            agentId: response?.agent?._id,
            formContent: response?.formContent,
            Stage: response?.stage.toString(),
            auditForm: response?.auditForm?._id,
            score: response?.auditedScoreInfo?.score,
            auditedQuestionCount: response?.auditedQuestionCount,
            transactionDuplicateReason: response?.transactionDuplicateReason,
            auditBackDateReason: response?.auditBackDateReason,
            insuredName: response?.insuredName,
            transactionAmount: response?.transactionAmount,
            invoiceCount: response?.invoiceCount,
            aditorID: response?.auditor?._id,
          }); //For sending audit details for auto save on change
          secureLocalStorage.setItem("aID", response?.agent?._id);

          setAID(response?.agent?._id);
          setTid(response?.transaction_id);
          setCommentStatus(response?.commentStatus);
          secureLocalStorage.setItem(
            "auditScore",
            secureLocalStorage.getItem("savePayloadRequestParams")?.score,
          );
          secureLocalStorage.setItem(
            "auditedQuestionCount",
            secureLocalStorage.getItem("savePayloadRequestParams")
              ?.auditedQuestionCount,
          );

          secureLocalStorage.setItem("auditedFormSubmit", false);
          if (response?.stage.toString() === "Audit Completed") {
            secureLocalStorage.setItem("auditedFormSubmit", true);
          }
        }

        if (id && secureLocalStorage.getItem("savePayloadRequestParams")) {
          var parsedQMF = JSON.parse(
            secureLocalStorage.getItem("savePayloadRequestParams")?.formContent,
          );

          setQMF(parsedQMF);
          setShowLoader(false);
        } else {
          if (secureLocalStorage.getItem("updatedQMF")) {
            let parsedQMF =
              secureLocalStorage.getItem("updatedQMF")?.formContent;
            setQMF(parsedQMF);
            setShowLoader(false);
          } else {
            let parsedQMF = JSON.parse(response.formContent);
            setQMF(parsedQMF);
            setShowLoader(false);
          }
        }
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };

  const getValue = (value, id, isQualityMetric, weightage, serial_no) => {
    if (
      (secureLocalStorage.getItem("role") === "admin" ||
        secureLocalStorage.getItem("role") === "auditor" ||
        secureLocalStorage.getItem("role") === "qc") &&
      ((secureLocalStorage.getItem("auditFormCall") !== "performAudit" &&
        (secureLocalStorage.getItem("savePayloadRequestParams")?.aditorID ===
          secureLocalStorage.getItem("lIUId") ||
          prevData?.auditorId === secureLocalStorage.getItem("lIUId"))) ||
        (secureLocalStorage.getItem("auditFormCall") === "performAudit" &&
          prevData?.auditorId === secureLocalStorage.getItem("lIUId")))
    ) {
      /*begin::Set array in the way user audited the parameters of the Audit Form*/
      if (value === "Yes" || value === "No" || value === "Not Applicable") {
        if (secureLocalStorage.getItem("parameterSelectedList")) {
          let parameterSelectedList = secureLocalStorage.getItem(
            "parameterSelectedList",
          );

          if (!parameterSelectedList.includes(id)) {
            parameterSelectedList.unshift(id);
          } else {
            parameterSelectedList = parameterSelectedList.filter(
              (x) => x !== id,
            );
            parameterSelectedList.unshift(id);
          }
          secureLocalStorage.setItem(
            "parameterSelectedList",
            parameterSelectedList,
          );
        } else {
          secureLocalStorage.setItem("parameterSelectedList", [id]);
        }
      } else {
        setFormSavingFieldType("others");
      }
      /*end::Set array in the way user audited the parameters of the Audit Form*/

      var questions = QMF?.elements?.questions;
      let totalWeightage = 0; //Variable to store overall weightage of audit form having parameter's weightage
      let aQCount = 1;
      let aQSCount = 1;
      let countQA = []; //Variable to store all user audited parameter's value
      let isCriticalParameterHasNo = false;

      for (let i = 0; i < questions?.length; i++) {
        if (questions[i]?.qkey === id) {
          questions[i].selectedValue = value; //This is setting value in new property selectedValue
        }

        //Setting variable flag if it is critical parameter
        if (
          questions[i]?.meta?.required === true &&
          questions[i].selectedValue === "No"
        ) {
          isCriticalParameterHasNo = true;
        }
        if (questions[i].meta.weightage) {
          totalWeightage = totalWeightage + questions[i].meta.weightage;
          setAuditFormHasWeightage("TRUE");
        }
        if (questions[i].input_type === "radio-group") {
          switch (questions[i].selectedValue) {
            case "Yes":
              secureLocalStorage.setItem(
                "auditedQuestionScoreCount",
                aQCount++,
              );
              countQA.push("Yes");
              break;
            case "No":
              countQA.push("No");
              break;
            case "Not Applicable":
              countQA.push("NotApplicable");
              if (secureLocalStorage.getItem("auditedQuestionScoreCount")) {
                if (
                  secureLocalStorage.getItem("auditedQuestionScoreCount") ===
                    1 &&
                  value === "Not Applicable" &&
                  auditFormHasWeightage === "TRUE"
                ) {
                  secureLocalStorage.setItem("auditedQuestionScoreCount", "0");
                }
              } else {
                secureLocalStorage.setItem("auditedQuestionScoreCount", "0");
              }
              break;

            default:
              break;
          }
        }

        if (questions[i].selectedValue && questions[i].selectedValue !== "") {
          secureLocalStorage.setItem("auditedQuestionCount", aQSCount++); //Setting for showing audited count for all questions of audit
        }
      }

      let fatalErrorCount = {};
      let nonFatalErrorCount = {};
      for (let i = 0; i < questions?.length; i++) {
        const key = questions[i]?.qkey;

        if (
          questions[i]?.meta?.critical === true &&
          questions[i]?.selectedValue === "No"
        ) {
          fatalErrorCount[key] = "No";
        }
        if (
          questions[i]?.meta?.critical === false &&
          questions[i]?.selectedValue === "No"
        ) {
          nonFatalErrorCount[key] = "No";
        }
      }

      setFatalCount(fatalErrorCount && Object.keys(fatalErrorCount).length);
      setNotFatalCount(
        nonFatalErrorCount && Object.keys(nonFatalErrorCount).length,
      );
      let countMap = {};
      countQA.forEach(function (i) {
        countMap[i] = (countMap[i] || 0) + 1;
      });
      if (countMap.NotApplicable) {
        setCrrScore(countQA && countQA.length - countMap.NotApplicable);
        setScoreQuestionCount(maxScore - countMap.NotApplicable);
      } else {
        setCrrScore(countQA && countQA.length);
        setScoreQuestionCount(maxScore);
      }
      setIsCritical(isCriticalParameterHasNo);

      if (auditFormHasWeightage === "FALSE" && countMap.No) {
        if (countMap.Yes) {
          setCrrScore(countMap && countMap.Yes);
        } else {
          setCrrScore(0);
        }
      }
      secureLocalStorage.setItem("countMap", countMap);

      if (value === "Yes" || value === "No" || value === "Not Applicable") {
        secureLocalStorage.setItem("clickedLink", "onChange");
      } else {
        secureLocalStorage.setItem("clickedLink", "textOnChangeRequest");
      }

      if (
        secureLocalStorage.getItem("savePayloadRequestParams")?.Stage !==
        "Audit Completed"
      ) {
        SetFormValue({
          ...formValue,
          [id]: [
            value,
            isQualityMetric,
            weightage,
            totalWeightage,
            "",
            isCriticalParameterHasNo,
          ],
        });
      } else {
      }

      if (auditFormAction === "") {
        setAuditFormAction("create");
      } else {
        setAuditFormAction("update");
      }
    }
  };

  /*begin::Submit Audit button functionality*/
  const onFinish = () => {
    setAuditFormAction("update");

    message.success("Submit success!");
    secureLocalStorage.setItem("auditedFormSubmit", true);
  };

  const onFinishFailed = () => {
    (Number(qualityScore) < 100 &&
      tCountForAlertMessage ===
        secureLocalStorage.getItem("auditedQuestionCount")) ||
    (Number(qualityScore) === 100 && crrScore === scoreQuestionCount)
      ? message.error("Submission failed!")
      : message.error(
          "Submission failed because the score is less than 100, and a mandatory question with an asterisk (*) is still unanswered!",
        );
  };
  /*end::Submit Audit button functionality*/

  useEffect(() => {
    /*Begin::Auto Save functionality onChange*/
    if (auditFormAction === "create") {
      if (formSavingFieldType === "") {
        setQualityScore(
          getScore(
            formValue,
            scoreQuestionCount,
            auditFormHasWeightage,
            "",
            isCritical,
          ),
        );
      }
    }
    if (auditFormAction === "update") {
      if (formSavingFieldType === "") {
        setQualityScore(
          getScore(
            formValue,
            scoreQuestionCount,
            auditFormHasWeightage,
            "",
            isCritical,
          ),
        );
      }
    }
    /*End::Auto Save functionality onChange*/
  }, [formValue]);

  const handleAuditsBack = () => {
    const allKeys = Object.keys(localStorage);
    // Loop through the keys and remove items that are not the specific item
    let exceptItems = [
      "@secure.s.lIU",
      "@secure.s.lIUId",
      "@secure.s.role",
      "@secure.s.accessToken",
      "@secure.s.accessTokenExpiry",
      "@secure.s.refreshToken",
      "@secure.s.refreshTokenExpiry",
    ];

    allKeys.forEach((key) => {
      if (!exceptItems.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    setGlobalState(false);
    navigate("/audits");
  };

  useEffect(() => {
    if (Number(qualityScore) < 100) {
      // Select all elements with the class 'text123'
      const elementsWithText123 = document.querySelectorAll(
        ".auditFormField .ant-form-item-control-input .ant-form-item-control-input-content",
      );

      // Loop through the selected elements and add an asterisk to each
      elementsWithText123.forEach((element) => {
        const specificChild = element.querySelector(".ant-radio-group");
        const text123Child = element.querySelector(".text123");

        if (!specificChild) {
          // Check if the next element is already an asterisk element
          const nextElement = text123Child?.nextElementSibling;
          if (
            nextElement &&
            nextElement.classList.contains("lessScoreMandatoryFields")
          ) {
            return; // Return early if the asterisk span already exists
          }

          // Create a span element with the asterisk symbol
          const asteriskSpan = document.createElement("span");
          asteriskSpan.innerText = " *";
          asteriskSpan.style.color = "red";
          asteriskSpan.classList.add("lessScoreMandatoryFields"); // Remove the = sign

          text123Child?.parentNode.insertBefore(
            asteriskSpan,
            text123Child?.nextSibling,
          );
        }
      });
    }
    if (Number(qualityScore) === 100) {
      // Select all spans with the class 'lessScoreMandatoryFields'
      const spansToRemove = document.querySelectorAll(
        ".lessScoreMandatoryFields",
      );

      // Loop through the selected spans and remove them
      spansToRemove.forEach((span) => {
        span.remove();
      });
    }
  }, [qualityScore]);

  const [tCountForAlertMessage, setTCountForAlertMessage] = useState("");

  const divStructure = secureLocalStorage.getItem("savePayloadRequestParams")
    ?.Stage !== "" &&
    Number(qualityScore) < 100 && (
      <span className="feedback-content">
        {((secureLocalStorage.getItem("role") === "tl" &&
          (addAgentFeedback === 1 || agentFeedback || supervisorFeedback)) ||
          (secureLocalStorage.getItem("role") === "agent" &&
            (addAgentFeedback === 0 || agentFeedback || supervisorFeedback) &&
            agentFeedback != "Accepted")) && (
          <>
            <strong>Feedback | </strong>{" "}
          </>
        )}

        {secureLocalStorage.getItem("role") === "admin" ||
        secureLocalStorage.getItem("role") === "tl" ||
        secureLocalStorage.getItem("role") === "atl"
          ? addAgentFeedback === 0 && agentFeedback
            ? "Agent : " + agentFeedback
            : "Agent : Awaited"
          : ""}
        {secureLocalStorage.getItem("role") === "admin" && ", "}
        {(secureLocalStorage.getItem("role") === "admin" ||
          secureLocalStorage.getItem("role") === "agent") &&
        agentFeedback &&
        agentFeedback != "Accepted"
          ? addSupervisorFeedback === 0 && supervisorFeedback
            ? "Supervisor : " + supervisorFeedback
            : "Supervisor : Awaited"
          : ""}
      </span>
    );

  const headLine = QMF?.elements?.meta?.headline;
  const singlePageContent = { divStructure, headLine };

  if (!hasViewAccess) {
    return <Unauthorized />;
  }
  return (
    <div className="single-page">
      <CustomLoader showLoader={showLoader} />
      <div className="auditFormTitlebar pb-16">
        <h2>{singlePageContent?.headLine}</h2>
        <ul className="auditedDetails">
          <li>
            <img
              src={
                !isAuditorImgBroken && auditorProfileImage?.profilePicUrl
                  ? auditorProfileImage?.profilePicUrl
                  : media.audited.svg
              }
              alt={auditorProfileImage?.name}
              title={auditorProfileImage?.name}
              onError={() => setIsAuditorImgBroken(true)}
            />
            <span>
              Audited:{" "}
              <span className="greyBackground">
                {crrScore}/{scoreQuestionCount}
              </span>
            </span>
          </li>
          <li>
            <span>
              Score: <span className="greyBackground">{qualityScore}%</span>
            </span>
          </li>
        </ul>
      </div>

      <div className="auditFormsDetailsRS plr-16">
        <div className="auditFormsWrapper">
          {hasPermission(
            accessMap,
            "qMSDeletedAuditsDetailView",
            "deletedAuditDetailAuditSectionView",
          ) && (
            <div className="auditFormsWrapperCol">
              <h3>Audit</h3>

              {QMF && ParseElementsIntoFormNew(QMF, getValue)}
            </div>
          )}
          {/*begin::To show Audit Details in right sidebar*/}
          {hasPermission(
            accessMap,
            "qMSDeletedAuditsDetailView",
            "deletedAuditDetailAuditDetailsSectionView",
          ) && (
            <div className="auditFormsWrapperCol">
              <DeletedAuditDetails
                auditFormInput={auditFormInput}
                fatalNotFatalInfo={{
                  fatal: { icon: "auditFatel", value: fatalCount },
                  notFatal: { icon: "auditNoFatel", value: notFatalCount },
                }}
                timeStampsDetails={secureLocalStorage.getItem(
                  "timeStampsDetails",
                )}
                qualityScore={qualityScore}
                auditorProfileImage={auditorProfileImage}
                agentProfileImage={agentProfileImage}
              />
            </div>
          )}
          {/*end::To show Audit Details in right sidebar*/}
        </div>
      </div>
    </div>
  );
};
export default DeletedAuditView;
